import { Button } from "@mui/material";
import React from "react";

const CustomButtons = ({
  variant,
  title,
  handleFunc,
  isDisabled,
  isMobileview,
}) => {
  return (
    <div>
      <Button
        variant={variant}
        style={{
          borderRadius: "12px",
          textTransform: "none",
          width: isMobileview ? "107px" : "136px",
          height: isMobileview ? "36px" : "50px",
        }}
        onClick={handleFunc}
        disabled={isDisabled}
        disableElevation
      >
        {title}
      </Button>
    </div>
  );
};

export default CustomButtons;
